import { openDialog } from '@patrianna/dialog-manager'
import * as Sentry from '@sentry/nextjs'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { getGameByCode, isGameProductErrorResponse } from 'src/utils/loadGameInfoGetInitialProps'
import { useAppSelector } from 'store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { needToVerifyEmailSelector } from 'store/modules/user/selectors'

export default function useGameDialogByQuery() {
  const pathname = usePathname()
  const query = useSearchParams()
  const gameCode = query.get('game-dialog')
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const emailNotVerified = useAppSelector(needToVerifyEmailSelector)

  useEffect(() => {
    if (appInitialized && gameCode) {
      window.history.replaceState({}, document.title, pathname)

      if (emailNotVerified) {
        // Unverified users are redirected to /confirm-email by useIsEmailVerified().
        // Skip opening the game dialog on top of that redirect.
        return
      }

      getGameByCode(gameCode).then((_game) => {
        if (!isGameProductErrorResponse(_game)) {
          openDialog({ dialogName: 'START_GAME_FLOW', dialogProps: { game: _game } })
          Sentry.captureMessage(`Open game dialog by query from page: ${pathname}`)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameCode, appInitialized, emailNotVerified])
}
